import packageJson from "../../../../package.json";
import {
  deserializeHoverIdleSaveData,
  serializeHoverIdleSaveData,
  type HoverIdleSaveDataResult,
} from "./hoverIdleSaveCodec";
import type { HoverIdleSaveData } from "./hoverIdleSaveData";

const APP_VERSION: string = packageJson.version;

export interface HoverIdleBackupFilenameOptions {
  readonly nowMs: number;
  readonly version?: string;
}

export function buildHoverIdleBackupFilename(
  options: HoverIdleBackupFilenameOptions,
): string {
  const version = options.version ?? APP_VERSION;
  const date = new Date(options.nowMs);
  const yyyy = date.getFullYear().toString().padStart(4, "0");
  const mm = (date.getMonth() + 1).toString().padStart(2, "0");
  const dd = date.getDate().toString().padStart(2, "0");
  const hh = date.getHours().toString().padStart(2, "0");
  const mi = date.getMinutes().toString().padStart(2, "0");
  return `HoverIdle${yyyy}${mm}${dd}_${hh}${mi}_v${version}.txt`;
}

export function encodeHoverIdleBackupText(saveData: HoverIdleSaveData): string {
  const json = serializeHoverIdleSaveData(saveData);
  const bytes = new TextEncoder().encode(json);
  let binary = "";
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary);
}

export function decodeHoverIdleBackupText(
  serialized: string,
): HoverIdleSaveDataResult {
  const trimmed = serialized.trim();
  let json: string;
  try {
    const binary = atob(trimmed);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    json = new TextDecoder("utf-8", { fatal: true }).decode(bytes);
  } catch (error) {
    return {
      ok: false,
      reason: error instanceof Error ? error.message : "invalid backup text",
    };
  }
  return deserializeHoverIdleSaveData(json);
}
